export const ManInvConcept = {
  1: 'RR/RBD/Delco',
  2: 'RR/RBD',
  3: 'RBD/Delco',
  4: 'Delco',
};

export type ManInvConceptKeys = keyof typeof ManInvConcept;

export const ManInvFrequency = {
  1: 'Daily',
  2: 'Weekly',
};

export type ManInvFrequencyKeys = keyof typeof ManInvFrequency;
